import { render, staticRenderFns } from "./28f1ef3d-8af9-495d-9ed0-45ee3dd9ef20.vue?vue&type=template&id=495ef9d8&scoped=true"
import script from "./28f1ef3d-8af9-495d-9ed0-45ee3dd9ef20.vue?vue&type=script&lang=ts"
export * from "./28f1ef3d-8af9-495d-9ed0-45ee3dd9ef20.vue?vue&type=script&lang=ts"
import style0 from "./28f1ef3d-8af9-495d-9ed0-45ee3dd9ef20.vue?vue&type=style&index=0&id=495ef9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ef9d8",
  null
  
)

export default component.exports